<template v-if="devTools">
  <li>
    <a href="javascript:void(0);" class="btn btn-lg btn-default" @click="openModel = true">
      <i class="fa fa-cube fa-fw txt-color-red"></i> Model
    </a>
    <a href="javascript:void(0);" class="btn btn-lg btn-default" @click="openSchema = true">
      <i class="fa fa-code fa-fw txt-color-red"></i> Schema
    </a>
    <span class="text-left" style="width:0;height:0;padding:0;border:0">
      <w-modal
        class="modal-lg"
        :open="openModel"
        @close="openModel = false"
        title="[SuperAdmin, DEBUG]: Model"
      >
        <template>
          <span class="dev-modals">
            <span>export default {{model}};</span>
            <input
              type="hidden"
              id="hiddenModel"
              :value="'export default '+ JSON.stringify(model) + ';'"
            >
          </span>
        </template>
        <template #footerBtn>
          <button type="button" class="btn btn-primary" @click="consoleLog(model, 'model')">
            <i class="fa fa-fw fa-terminal"></i>
            console.log(model)
          </button>
          <button type="button" class="btn btn-primary" @click="copyToClipboard('hiddenModel')">
            <i class="fa fa-fw fa-clipboard"></i>
            Kopiuj do schowka
          </button>
          <button type="button" class="btn btn-danger" @click="clearModel(model)">
            <i class="fa fa-fw fa-window-close"></i>
            Wyczyść Model
          </button>
        </template>
      </w-modal>
      <w-modal
        class="modal-lg"
        :open="openSchema"
        @close="openSchema = false"
        title="[SuperAdmin, DEBUG]: Schema"
      >
        <template>
          <span class="dev-modals">{{schema}}</span>
        </template>
        <template #footerBtn>
          <button type="button" class="btn btn-primary" @click="consoleLog(schema, '$schema')">
            <i class="fa fa-fw fa-terminal"></i>
            console.log(model)
          </button>
        </template>
      </w-modal>
    </span>
  </li>
</template>
<script>
import WModal from '../modal.vue';
export default {
  props: {
    model: Object,
    schema: Object
  },
  data() {
    return {
      devTools: process.env.NODE_ENV === 'development',
      openModel: false,
      openSchema: false
    };
  },
  // mounted() {},
  components: {WModal},
  computed: {},
  methods: {
    clearModel(model) {
      for (const key in model) {
        if (model == null) {
          continue;
        }

        if (model[key] != null) {
          // clear
          if (typeof model[key] === 'function') {
            continue;
          } else if (Array.isArray(typeof model[key])) {
            model[key] = [];
          } else if (typeof model[key] === 'object') {
            clearModel(model[key]);
          } else if (typeof model[key] === 'string') {
            model[key] = '';
          } else if (typeof model[key] === 'number') {
            model[key] = null;
          }
        }
      }
      // TODO: nie działa this.$set(this, "model", {})
    },
    copyToClipboard(id) {
      console.log(this.model);
      const copyText = document.querySelector('#' + id);
      copyText.setAttribute('type', 'text');
      copyText.select();
      try {
        document.execCommand('copy');
      } catch (err) {
        if (process.env.NODE_ENV === 'development') {
          console.error('copy error', err);
        }
      }
      copyText.setAttribute('type', 'hidden');
      window.getSelection().removeAllRanges();
    },
    consoleLog(model, title) {
      console.log(title ? title + ': ' : 'clicked console log: ', model);
    }
  }
};
</script>
<style scoped>
.dev-modals {
  white-space: pre-wrap; /* CSS3 */
  white-space: -moz-pre-wrap; /* Firefox */
  white-space: -pre-wrap; /* Opera <7 */
  white-space: -o-pre-wrap; /* Opera 7 */
  word-wrap: break-word; /* IE */
}
</style>